// import { useState } from "react";

import styled from "styled-components";
import { Form } from "antd";
// import { Space } from "antd";
// import colors from "constants/palette";
import Select from "components/inputs/Select";

export default function DataController() {
  return (
    <Container>
      <label>بر اساس :</label>
      <Form.Item
        name="filter"
        rules={[
          {
            required: true,
            message: "لطفا فیلتر را وارد کنید!",
          },
        ]}
      >
        <Select
          borderradius="0"
          list={list}
          showSearch
          placeholder="جستجو"
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          filterSort={(optionA, optionB) =>
            optionA.children
              .toLowerCase()
              .localeCompare(optionB.children.toLowerCase())
          }
        />
      </Form.Item>
    </Container>
  );
}
const Container = styled.div``;
const Section = styled.div``;

const list = [
  { title: "همه" },
  { title: "مشتری" },
  { title: "شهر" },
  { title: "ویزیتور" },
  { title: "وضعیت" },
];
